// extracted by mini-css-extract-plugin
export default {"discount-price":"SpiILS","discountPrice":"SpiILS","hidden":"UaXnaK"};